// ** Reducers Imports
import tableStore from "../Components/tableStore"
const rootReducer = {
  tableStore
}

export default rootReducer
